import { Simdata5gService } from 'src/services/simdata5g.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const SIMDATA5G_NEW_CARE_SUCCESS = 'SIMDATA5G:NEW_CARE_SUCCESS'
export const SIMDATA5G_LIST_SUCCESS = 'SIMDATA5G:FIND_ALL_SUCCESS'
export const SIMDATA5G_LIST_FAILD = 'SIMDATA5G:FIND_ALL_FAILD'
export const SIMDATA5G_COUNT_ASSIGN_SUCCESS = 'SIMDATA5G:COUNT_ASSIGN_SUCCESS'
export const SIMDATA5G_COUNT_ASSIGN_FAILD = 'SIMDATA5G:COUNT_ASSIGN_FAILD'

export const SIMDATA5G_CREATE_SUCCESS = 'SIMDATA5G:CREATE_SUCCESS'
export const SIMDATA5G_CREATE_FAILD = 'SIMDATA5G:CREATE_FAILD'

export const SIMDATA5G_IMPORT_SUCCESS = 'SIMDATA5G:IMPORT_SUCCESS'
export const SIMDATA5G_SAVE_SUCCESS = 'SIMDATA5G:SAVE_SUCCESS'
export const SIMDATA5G_SAVE_FAILD = 'SIMDATA5G:SAVE_SUCCESS'

export const SIMDATA5G_DEL_SUCCESS = 'SIMDATA5G:DEL_SUCCESS'
export const SIMDATA5G_DEL_FAILD = 'SIMDATA5G:DEL_FAILD'

export const SIMDATA5G_ONE_SUCCESS = 'SIMDATA5G:FIND_ONE_SUCCESS'
export const SIMDATA5G_ONE_FAILD = 'SIMDATA5G:FIND_ONE_FAILD'

export const SIMDATA5G_HISTORY_LIST_SUCCESS = 'SIMDATA5G:HISTORY_FIND_ALL_SUCCESS'
export const SIMDATA5G_HISTORY_LIST_FAILD = 'SIMDATA5G:HISTORY_FIND_ALL_FAILD'

export const SIMDATA5G_UPDATE_FILTER = 'SIMDATA5G:UPDATE_FILTER'

export const SIMDATA5G_ORDER_SUCCESS = 'SIMDATA5G:ORDER_SUCCESS'
export const SIMDATA5G_ORDER_FAILD = 'SIMDATA5G:ORDER_FAILD'

export const SIMDATA5G_UPDATE_HOMEPAGE_FILTER = 'SIMDATA5G:SIMDATA5G_UPDATE_HOMEPAGE_FILTER'

export const SIMDATA5G_HOMEPAGE_LIST_SUCCESS = 'SIMDATA5G:FIND_HOMEPAGE_LIST_SUCCESS'
export const SIMDATA5G_HOMEPAGE_LIST_FAILD = 'SIMDATA5G:FIND_HOMEPAGE_LIST_FAILD'

export const SIMDATA5G_HOMEPAGE_ONE_SUCCESS = 'SIMDATA5G:FIND_HOMEPAGE_ONE_SUCCESS'
export const SIMDATA5G_HOMEPAGE_ONE_FAILD = 'SIMDATA5G:FIND_HOMEPAGE_ONE_FAILD'

export const SIMDATA5G_LIMIT_UPDATE_HOMEPAGE_FILTER = 'SIMDATA5G:SIMDATA5G_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const SIMDATA5G_LIMIT_HOMEPAGE_LIST_SUCCESS = 'SIMDATA5G:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const SIMDATA5G_LIMIT_HOMEPAGE_LIST_FAILD = 'SIMDATA5G:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const SIMDATA5G_LIMIT_HOMEPAGE_ONE_SUCCESS = 'SIMDATA5G:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const SIMDATA5G_LIMIT_HOMEPAGE_ONE_FAILD = 'SIMDATA5G:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const Simdata5gAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,

    homepageList,
    updateHomepageFilter,
    homepageFindOne,

    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,

    sendOrder,
}

function updateHomepageFilter(payload) {
    return { type: SIMDATA5G_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { simdata5g } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageSimdata5gFilter } = simdata5g;
        const homepageSimdata5gPage = homepageSimdata5gFilter.homepageSimdata5gPage;
        const homepageSimdata5gLimit = homepageSimdata5gFilter.homepageSimdata5gLimit;

        return new Promise((resolve, reject) => {
            Simdata5gService.homepageList(homepageSimdata5gFilter).then((rs) => {
                if (!!homepageSimdata5gFilter && homepageSimdata5gFilter.homepageSimdata5gPage === 0) {
                    dispatch(success({
                        homepageSimdata5gItems: rs.data.values,
                        homepageSimdata5gTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = simdata5g.homepageSimdata5gItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageSimdata5gLimit * homepageSimdata5gPage; i < homepageSimdata5gLimit * homepageSimdata5gPage + homepageSimdata5gLimit; i++) {
                        if (typeof rsDataValues[i - homepageSimdata5gLimit * homepageSimdata5gPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageSimdata5gLimit * homepageSimdata5gPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageSimdata5gItems: uniqueItems,
                        homepageSimdata5gTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMDATA5G_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: SIMDATA5G_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { simdata5g } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageSimdata5gLimitFilter } = simdata5g;
        const homepageSimdata5gLimitPage = homepageSimdata5gLimitFilter.homepageSimdata5gLimitPage;
        const homepageSimdata5gLimitLimit = homepageSimdata5gLimitFilter.homepageSimdata5gLimitLimit;

        return new Promise((resolve, reject) => {
            Simdata5gService.homepageLimitList(homepageSimdata5gLimitFilter).then((rs) => {
                if (!!homepageSimdata5gLimitFilter && homepageSimdata5gLimitFilter.homepageSimdata5gLimitPage === 0) {
                    dispatch(success({
                        homepageSimdata5gLimitItems: rs.data.values,
                        homepageSimdata5gLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = simdata5g.homepageSimdata5gLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageSimdata5gLimitLimit * homepageSimdata5gLimitPage; i < homepageSimdata5gLimitLimit * homepageSimdata5gLimitPage + homepageSimdata5gLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageSimdata5gLimitLimit * homepageSimdata5gLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageSimdata5gLimitLimit * homepageSimdata5gLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageSimdata5gLimitItems: uniqueItems,
                        homepageSimdata5gLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: SIMDATA5G_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: SIMDATA5G_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            Simdata5gService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(Simdata5gAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: SIMDATA5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            Simdata5gService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(Simdata5gAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: SIMDATA5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { simdata5g } = getState()
        dispatch(AppAction.appLoading(true));
        Simdata5gService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...simdata5g.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { simdata5g } = getState();
        const page = simdata5g && typeof simdata5g.filter !== 'undefined' && simdata5g.filter && typeof simdata5g.filter.page !== 'undefined' ? simdata5g.filter.page : 0;
        const limit = simdata5g && typeof simdata5g.filter !== 'undefined' && simdata5g.filter && typeof simdata5g.filter.limit !== 'undefined' ? simdata5g.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            Simdata5gService.findAll(page, limit, simdata5g.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = simdata5g.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: SIMDATA5G_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: SIMDATA5G_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            Simdata5gService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(Simdata5gAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: SIMDATA5G_SAVE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            Simdata5gService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(Simdata5gAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
                alert("Không thể tạo, có thể do trùng tên sản phẩm trước đó!");
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: SIMDATA5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(Simdata5gAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_CREATE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(Simdata5gAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_DEL_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_ONE_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(Simdata5gAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { simdata5g } = getState()
        dispatch(AppAction.appLoading(true));
        Simdata5gService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...simdata5g.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        Simdata5gService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt này do hiện tại đang tạm hết hàng. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: SIMDATA5G_ORDER_SUCCESS, data } }
    function failure(error) { return { type: SIMDATA5G_ORDER_FAILD, error } }
}